<template>
  <v-container fluid fill-height justify-center align-start align-lg-center id="scrolling-techniques-7" class="overflow-y-auto" key="settings">
    <v-row class="max-w">
      <v-col cols="12">
        <div class="headline font-weight-bold relative px-4 mt-2 text--primary">
          {{ $t('Ustawienia') }}
        </div>
      </v-col>
      <v-col cols="12">
        <v-list
          two-line
          flat
          class="transparent"
        >
          
          <v-list-item>
              <v-list-item-icon>
                <!--<v-icon>mdi-key</v-icon>-->
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>{{ controller.controllerId }}</v-list-item-title>
                <v-list-item-subtitle>{{ $t('id-sterownika') }}</v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-action>
                
              </v-list-item-action>
          </v-list-item>
          <v-list-item>
              <v-list-item-icon>
                
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>{{ controller.brandName }}</v-list-item-title>
                <v-list-item-subtitle>{{ $t('Producent') }}</v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-action>
                
              </v-list-item-action>
          </v-list-item>
          <v-list-item :to="'/controllers/' + controllerId" class="br-3 rised my-2">
              <v-list-item-icon>
                <v-icon>mdi-heart</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>{{ controller.displayName }}</v-list-item-title>
                <v-list-item-subtitle>{{ $t('display-name') }}</v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-action>
                <v-icon>mdi-chevron-right</v-icon>
              </v-list-item-action>
          </v-list-item>
        </v-list>
      </v-col>
      <v-col cols="12" offset="0">
        <v-divider></v-divider>
      </v-col>
      <v-col cols="12">
        <v-list
          one-line
          flat
          class="transparent"
        >
          <v-list-item :to="'/controllers/delete/' + controllerId" class="br-3">
              <v-list-item-icon>
                <v-icon>mdi-delete</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>{{ $t('Usun-ster') }}</v-list-item-title>
                <v-list-item-subtitle></v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-action>
                <v-icon>mdi-chevron-right</v-icon>
              </v-list-item-action>
          </v-list-item>

        </v-list>
      </v-col>

    </v-row>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  data: () => ({
    inactive: true
  }),
  computed: {
    ...mapGetters([
      'controllers',
      'controllerById'
    ]),
    controllerId() {
      return this.$route.params.controllerId;
    },
    controller() {
      return this.controllerById(this.controllerId)
    }
  },
  created () {
    if (!(this.$store && this.$store.state)) {
      this.$router.push({ path: '/dashboard/' + this.controllerId });
    } else {
      
    }
  },
  mounted () {
    //setTimeout(() => { this.inactive = false; }, 200);
  },
  methods: {

  }
}
</script>

<style>

</style>
